/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const PractMgrReferenceFragment = `
    fragment PractMgrReferenceFragment on Reference {
  id
  display
}
    `
export const PracticeMgrAnnotationFragment = `
    fragment PracticeMgrAnnotationFragment on Annotation {
  authorReference {
    ...PractMgrReferenceFragment
  }
  time
  text
}
    `
export const TocConfigurationFragment = `
    fragment TocConfigurationFragment on TocConfiguration {
  referralSourceFilter
  fuh7
  fuh30
  fum7
  fum30
}
    `
export const InsurancePlanFullFragment = `
    fragment InsurancePlanFullFragment on InsurancePlanFull {
  _id
  payerCode
  name
  stateName
  stateCode
  status
  isInNetwork
  inNetworkBenefitTerms
  outOfNetworkBenefitTerms
  payerId
  entityName
  taxId
  groupNpi
  payerName
  vendorName
  notes
  lineOfBusiness
  verificationPayerId
  verificationPayerName
  verificationDefaultProviderName
  verificationDefaultProviderNpi
  verificationDefaultLocation
  groupId
  planId
  planType
  effectiveDate
  recredentialingDate
  expirationDate
  isDelegated
  delegatedEffectiveDate
  delegatedAuditDate
  comments {
    ...PracticeMgrAnnotationFragment
  }
  billingPayerName
  credentialingPayerId
  credentialingPayerName
  tocConfiguration {
    ...TocConfigurationFragment
  }
  isInheritanceDisabled
  companyName
  identifiers {
    type
    value
  }
}
    `
export const VerificationInsurancePlanFragment = `
    fragment VerificationInsurancePlanFragment on InsurancePlanFull {
  _id
  payerCode
  payerName
  payerId
  name
  stateName
  stateCode
  isInNetwork
  inNetworkBenefitTerms
  outOfNetworkBenefitTerms
  lineOfBusiness
  verificationPayerId
  verificationDefaultProviderName
  verificationDefaultProviderNpi
  verificationDefaultLocation
  planType
  billingPayerName
  isInheritanceDisabled
  credentialingPayerId
  credentialingPayerName
}
    `
export const MinimalProviderLicenseFragment = `
    fragment MinimalProviderLicenseFragment on ProviderLicense {
  licenseType
  stateCode
  status
}
    `
export const ProviderMinimalFragment = `
    fragment ProviderMinimalFragment on Provider {
  _id
  careManagerId
  firstName
  lastName
  display {
    expandedName
    legalName
    qualifiedName
  }
  status
  availability
  careManagerId
  employment {
    _id
    profession
    role
    status
  }
  licenses {
    ...MinimalProviderLicenseFragment
  }
}
    `
export const ExpectedHoursFragment = `
    fragment ExpectedHoursFragment on ExpectedHours {
  weeklyMinutesTotal
  serviceCategory {
    code
  }
  startDate
  endDate
}
    `
export const EmploymentFragment = `
    fragment EmploymentFragment on Employment {
  _id
  type
  status
  title
  role
  hireDate
  startDate
  terminationDate
  profession
  legalSex
  stateOfResidence
  onboardingCompleteDate
}
    `
export const ProviderIdentifierFragment = `
    fragment ProviderIdentifierFragment on ProviderIdentifier {
  id
  type
  value
  createdDate
  lastModified
}
    `
export const BaseProviderFragment = `
    fragment BaseProviderFragment on Provider {
  _id
  careManagerId
  status
  firstName
  lastName
  email
  genderIdentity
  communityIdentity
  race
  ethnicity
  languages
  spirituality
  ages
  modalities
  specialties
  bio
  clinicalAges
  clinicalModalities
  clinicalSpecialties
  expectedHours {
    ...ExpectedHoursFragment
  }
  status
  supervisor {
    ...PractMgrReferenceFragment
  }
  supervisees {
    ...PractMgrReferenceFragment
  }
  careCoordinator {
    ...PractMgrReferenceFragment
  }
  availability
  availabilityNotes
  teamLead {
    ...PractMgrReferenceFragment
  }
  employment {
    ...EmploymentFragment
  }
  identifiers {
    ...ProviderIdentifierFragment
  }
  serviceTypes
  nextgenTimezone
}
    `
export const FullInsurancePlanPartialFragment = `
    fragment FullInsurancePlanPartialFragment on InsurancePlanPartial {
  _id
  payerCode
  name
  stateName
  stateCode
  status
  isInheritanceDisabled
  credentialingPayerId
  credentialingPayerName
  isDelegated
}
    `
export const FileFragment = `
    fragment FileFragment on File {
  mimeType
  name
  url
}
    `
export const AttachmentAnnotationFragment = `
    fragment AttachmentAnnotationFragment on AttachmentAnnotation {
  authorReference {
    ...PractMgrReferenceFragment
  }
  time
  text
  attachments {
    ...FileFragment
  }
}
    `
export const FullInsurancePlanParticipantFragment = `
    fragment FullInsurancePlanParticipantFragment on InsurancePlanParticipant {
  _id
  effectiveDate
  terminationDate
  insurancePlan {
    ...FullInsurancePlanPartialFragment
  }
  billingRelationship {
    type
    reference {
      ...PractMgrReferenceFragment
    }
  }
  status
  comments {
    ...AttachmentAnnotationFragment
  }
}
    `
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const ProviderLicenseFragment = `
    fragment ProviderLicenseFragment on ProviderLicense {
  id
  licenseType
  stateCode
  status
  number
  durationType
  issueDate
  expirationDate
  created {
    ...AuditEntryFragment
  }
  modified {
    ...AuditEntryFragment
  }
  excludeFromPayerEnrollment
}
    `
export const UserSummaryDisplayNamesFragment = `
    fragment UserSummaryDisplayNamesFragment on UserSummaryDisplayNames {
  fullName
  qualifiedName
  legalName
  legalQualifiedName
  expandedName
  publicName
}
    `
export const ProviderTagFragment = `
    fragment ProviderTagFragment on ProviderTag {
  value
}
    `
export const ProviderFragment = `
    fragment ProviderFragment on Provider {
  ...BaseProviderFragment
  insurancePlans {
    ...FullInsurancePlanParticipantFragment
  }
  licenses {
    ...ProviderLicenseFragment
  }
  display {
    ...UserSummaryDisplayNamesFragment
  }
  tags {
    ...ProviderTagFragment
  }
}
    `
export const SearchInsurancePlanFragment = `
    fragment SearchInsurancePlanFragment on InsurancePlanFull {
  _id
  payerCode
  name
  stateName
  stateCode
}
    `
export const AllInsurancePlansMinimalFragment = `
    fragment AllInsurancePlansMinimalFragment on InsurancePlanFull {
  _id
  name
  stateCode
  status
  isInNetwork
  payerCode
}
    `
export const MinimalInsurancePlanParticipantFragment = `
    fragment MinimalInsurancePlanParticipantFragment on InsurancePlanParticipant {
  insurancePlan {
    _id
    name
    stateCode
    status
  }
  billingRelationship {
    reference {
      display
    }
  }
}
    `
export const SearchProviderFragment = `
    fragment SearchProviderFragment on Provider {
  sort
  ...BaseProviderFragment
  insurancePlans {
    ...MinimalInsurancePlanParticipantFragment
  }
  licenses {
    ...MinimalProviderLicenseFragment
  }
}
    `
export const ProviderLicenseRequestFragment = `
    fragment ProviderLicenseRequestFragment on ProviderLicenseRequest {
  id
  licenseType
  stateCode
  status
  durationType
  requestType
  submitDate
  psvSubmitDate
  completeDate
  created {
    ...AuditEntryFragment
  }
  modified {
    ...AuditEntryFragment
  }
  comments {
    ...PracticeMgrAnnotationFragment
  }
}
    `
export const AddressFragment = `
    fragment AddressFragment on Address {
  text
  line
  city
  state
  postalCode
  countryCode
}
    `
export const CodeableConceptFragment = `
    fragment CodeableConceptFragment on CodeableConcept {
  code
  text
  coding {
    system
    code
    display
  }
}
    `
export const IdentifierFragment = `
    fragment IdentifierFragment on Identifier {
  value
  type {
    ...CodeableConceptFragment
  }
  period {
    startDate
    endDate
  }
}
    `
export const LocationFragment = `
    fragment LocationFragment on Location {
  id
  name
  physicalType {
    ...CodeableConceptFragment
  }
  address {
    state
  }
}
    `
export const ProviderDocumentFragment = `
    fragment ProviderDocumentFragment on ProviderDocument {
  id
  file {
    ...FileFragment
  }
  documentCategory
  stateCode
  status
  created {
    ...AuditEntryFragment
  }
  modified {
    ...AuditEntryFragment
  }
  statusUpdated {
    ...AuditEntryFragment
  }
}
    `
export const PayerSummaryFrag = `
    fragment PayerSummaryFrag on Payer {
  id
  name
  stateCode
  status
}
    `
export const PayerEnrollmentFragment = `
    fragment PayerEnrollmentFragment on PayerEnrollment {
  id
  payer {
    ...PayerSummaryFrag
  }
  status
  vendor
  payerExternalProviderId
  submissionDate
  effectiveDate
  recredentialingDate
  expirationDate
  terminationDate
  comments {
    ...AttachmentAnnotationFragment
  }
  created {
    ...AuditEntryFragment
  }
  updated {
    ...AuditEntryFragment
  }
}
    `
export const PayerFragment = `
    fragment PayerFragment on Payer {
  id
  name
  stateCode
  status
  note
  comments {
    ...PracticeMgrAnnotationFragment
  }
  taxEntityId
  lineOfBusiness
  identifiers {
    type
    value
  }
  tags {
    value
  }
  delegated
}
    `
export const InternationalAddressFragment = `
    fragment InternationalAddressFragment on InternationalAddress {
  line
  city
  state
  postalCode
  countryCode
}
    `
export const ProfessionalHistoryFragment = `
    fragment ProfessionalHistoryFragment on ProfessionalHistory {
  id
  category
  programType
  institutionName
  degree
  startDate
  endDate
  completed
  notes
  organizationName
  certificationNumber
  recertificationDate
  examType
  examDate
  numberOfAttempts
  specialty
  title
  address {
    ...InternationalAddressFragment
  }
  created {
    ...AuditEntryFragment
  }
  modified {
    ...AuditEntryFragment
  }
}
    `
export const EncryptedValueFragment = `
    fragment EncryptedValueFragment on EncryptedValue {
  display
  cipherText
  algorithm
}
    `
export const ProviderCredentialingFragment = `
    fragment ProviderCredentialingFragment on ProviderCredentialing {
  firstName
  middleName
  lastName
  suffix
  priorLastName
  dateOfBirth
  birthCountry
  isUSCitizen
  personalEmail
  primaryPhone
  address {
    ...InternationalAddressFragment
  }
  ssn {
    ...EncryptedValueFragment
  }
  initialCredentialingDate
  currentCredentialingDate
  recredentialingDate
  lastRecredentialingDate
}
    `
export const ProviderExternalAccountFragment = `
    fragment ProviderExternalAccountFragment on ProviderExternalAccount {
  id
  type
  username
  note
  password {
    ...EncryptedValueFragment
  }
}
    `
export const PracticeStateFragment = `
    fragment PracticeStateFragment on PracticeState {
  id
  stateCode
  entityName
  taxId
  groupNpi
  qualifyingPayerLicenseTypes
  availabilityStatus
}
    `
export const PracticeTaxEntityFragment = `
    fragment PracticeTaxEntityFragment on PracticeTaxEntity {
  id
  entityName
  taxId
  groupNpi
}
    `
export const ProviderPlanParticipantFragment = `
    fragment ProviderPlanParticipantFragment on ProviderPlanParticipant {
  _id
  insurancePlan {
    ...FullInsurancePlanPartialFragment
  }
  participatingProvider {
    ...PractMgrReferenceFragment
  }
  billingRelationship {
    type
    reference {
      ...PractMgrReferenceFragment
    }
  }
  status
}
    `
export const UpdateProviderDocument = `
    mutation updateProvider($id: ID!, $content: ProviderInputUpdate!) {
  updateProvider(_id: $id, content: $content) {
    ...ProviderFragment
  }
}
    ${ProviderFragment}
${BaseProviderFragment}
${ExpectedHoursFragment}
${PractMgrReferenceFragment}
${EmploymentFragment}
${ProviderIdentifierFragment}
${FullInsurancePlanParticipantFragment}
${FullInsurancePlanPartialFragment}
${AttachmentAnnotationFragment}
${FileFragment}
${ProviderLicenseFragment}
${AuditEntryFragment}
${UserSummaryDisplayNamesFragment}
${ProviderTagFragment}`
export const AppendInsurancePlanParticipantsDocument = `
    mutation appendInsurancePlanParticipants($providerId: ID!, $content: [InsurancePlanParticipantInput!]) {
  appendInsurancePlanParticipants(providerId: $providerId, content: $content) {
    _id
  }
}
    `
export const UpdateInsurancePlanParticipantDocument = `
    mutation updateInsurancePlanParticipant($providerId: ID!, $content: InsurancePlanParticipantInput!) {
  updateInsurancePlanParticipant(providerId: $providerId, content: $content) {
    _id
  }
}
    `
export const RemoveInsurancePlanParticipantsDocument = `
    mutation removeInsurancePlanParticipants($providerId: ID!, $content: [InsurancePlanParticipantInput!]) {
  removeInsurancePlanParticipants(providerId: $providerId, content: $content) {
    _id
  }
}
    `
export const UpsertInsurancePlanParticipantsDocument = `
    mutation upsertInsurancePlanParticipants($content: [UpsertInsurancePlanParticipantInput!]!) {
  upsertInsurancePlanParticipants(content: $content) {
    _id
  }
}
    `
export const CreateInsurancePlanDocument = `
    mutation createInsurancePlan($content: InsurancePlanCreateInput!) {
  createInsurancePlan(content: $content) {
    ...InsurancePlanFullFragment
  }
}
    ${InsurancePlanFullFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}
${TocConfigurationFragment}`
export const UpdateInsurancePlanDocument = `
    mutation updateInsurancePlan($id: ID!, $content: InsurancePlanUpdateInput!) {
  updateInsurancePlan(_id: $id, content: $content) {
    ...InsurancePlanFullFragment
  }
}
    ${InsurancePlanFullFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}
${TocConfigurationFragment}`
export const DeleteInsurancePlanDocument = `
    mutation deleteInsurancePlan($id: ID!) {
  deleteInsurancePlan(_id: $id) {
    ...InsurancePlanFullFragment
  }
}
    ${InsurancePlanFullFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}
${TocConfigurationFragment}`
export const AppendProviderLicensesDocument = `
    mutation appendProviderLicenses($providerId: ID!, $content: [ProviderLicenseCreateInput!]!) {
  appendProviderLicenses(providerId: $providerId, content: $content) {
    ...ProviderLicenseFragment
  }
}
    ${ProviderLicenseFragment}
${AuditEntryFragment}`
export const UpdateProviderLicensesDocument = `
    mutation updateProviderLicenses($providerId: ID!, $content: [ProviderLicenseUpdateInput!]!) {
  updateProviderLicenses(providerId: $providerId, content: $content) {
    ...ProviderLicenseFragment
  }
}
    ${ProviderLicenseFragment}
${AuditEntryFragment}`
export const RemoveProviderLicensesDocument = `
    mutation removeProviderLicenses($providerId: ID!, $licenseIds: [ID!]!) {
  removeProviderLicenses(providerId: $providerId, licenseIds: $licenseIds) {
    ...ProviderLicenseFragment
  }
}
    ${ProviderLicenseFragment}
${AuditEntryFragment}`
export const AddProviderLicenseRequestsDocument = `
    mutation addProviderLicenseRequests($providerId: ID!, $content: [ProviderLicenseRequestCreateInput!]!) {
  addProviderLicenseRequests(providerId: $providerId, content: $content) {
    ...ProviderLicenseRequestFragment
  }
}
    ${ProviderLicenseRequestFragment}
${AuditEntryFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const UpdateProviderLicenseRequestsDocument = `
    mutation updateProviderLicenseRequests($providerId: ID!, $content: [ProviderLicenseRequestUpdateInput!]!) {
  updateProviderLicenseRequests(providerId: $providerId, content: $content) {
    ...ProviderLicenseRequestFragment
  }
}
    ${ProviderLicenseRequestFragment}
${AuditEntryFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const RemoveProviderLicenseRequestsDocument = `
    mutation removeProviderLicenseRequests($providerId: ID!, $licenseIds: [ID!]!) {
  removeProviderLicenseRequests(providerId: $providerId, licenseIds: $licenseIds) {
    ...ProviderLicenseRequestFragment
  }
}
    ${ProviderLicenseRequestFragment}
${AuditEntryFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const AppendProviderDocumentsDocument = `
    mutation appendProviderDocuments($providerId: ID!, $content: [CreateProviderDocumentInput!]!) {
  appendProviderDocuments(providerId: $providerId, content: $content) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const UpdateProviderDocumentsDocument = `
    mutation updateProviderDocuments($providerId: ID!, $content: [UpdateProviderDocumentInput!]!) {
  updateProviderDocuments(providerId: $providerId, content: $content) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const RemoveProviderDocumentsDocument = `
    mutation removeProviderDocuments($providerId: ID!, $documentIds: [ID!]!) {
  removeProviderDocuments(providerId: $providerId, documentIds: $documentIds) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const AppendVerifiedProviderDocumentsDocument = `
    mutation appendVerifiedProviderDocuments($providerId: ID!, $content: [CreateProviderDocumentInput!]!) {
  appendVerifiedProviderDocuments(providerId: $providerId, content: $content) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const UpdateVerifiedProviderDocumentsDocument = `
    mutation updateVerifiedProviderDocuments($providerId: ID!, $content: [UpdateProviderDocumentInput!]!) {
  updateVerifiedProviderDocuments(providerId: $providerId, content: $content) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const RemoveVerifiedProviderDocumentsDocument = `
    mutation removeVerifiedProviderDocuments($providerId: ID!, $documentIds: [ID!]!) {
  removeVerifiedProviderDocuments(
    providerId: $providerId
    documentIds: $documentIds
  ) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const CreatePayerEnrollmentsDocument = `
    mutation createPayerEnrollments($providerId: ID!, $content: [CreatePayerEnrollmentInput!]!) {
  createPayerEnrollments(providerId: $providerId, content: $content) {
    ...PayerEnrollmentFragment
  }
}
    ${PayerEnrollmentFragment}
${PayerSummaryFrag}
${AttachmentAnnotationFragment}
${PractMgrReferenceFragment}
${FileFragment}
${AuditEntryFragment}`
export const UpdatePayerEnrollmentsDocument = `
    mutation updatePayerEnrollments($providerId: ID!, $content: [UpdatePayerEnrollmentInput!]!) {
  updatePayerEnrollments(providerId: $providerId, content: $content) {
    ...PayerEnrollmentFragment
  }
}
    ${PayerEnrollmentFragment}
${PayerSummaryFrag}
${AttachmentAnnotationFragment}
${PractMgrReferenceFragment}
${FileFragment}
${AuditEntryFragment}`
export const DeletePayerEnrollmentsDocument = `
    mutation deletePayerEnrollments($providerId: ID!, $enrollmentIds: [ID!]!) {
  deletePayerEnrollments(providerId: $providerId, enrollmentIds: $enrollmentIds) {
    ...PayerEnrollmentFragment
  }
}
    ${PayerEnrollmentFragment}
${PayerSummaryFrag}
${AttachmentAnnotationFragment}
${PractMgrReferenceFragment}
${FileFragment}
${AuditEntryFragment}`
export const CreatePayersDocument = `
    mutation createPayers($content: [PayerCreateInput!]!) {
  createPayers(content: $content) {
    ...PayerFragment
  }
}
    ${PayerFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const UpdatePayersDocument = `
    mutation updatePayers($content: [PayerUpdateInput!]!) {
  updatePayers(content: $content) {
    ...PayerFragment
  }
}
    ${PayerFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const DeletePayersDocument = `
    mutation deletePayers($content: [ID!]!) {
  deletePayers(content: $content) {
    ...PayerFragment
  }
}
    ${PayerFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const CreateProfessionalHistoryDocument = `
    mutation createProfessionalHistory($providerId: ID!, $content: [ProfessionalHistoryCreateInput!]!) {
  createProfessionalHistory(providerId: $providerId, content: $content) {
    ...ProfessionalHistoryFragment
  }
}
    ${ProfessionalHistoryFragment}
${InternationalAddressFragment}
${AuditEntryFragment}`
export const UpdateProfessionalHistoryDocument = `
    mutation updateProfessionalHistory($providerId: ID!, $content: [ProfessionalHistoryUpdateInput!]!) {
  updateProfessionalHistory(providerId: $providerId, content: $content) {
    ...ProfessionalHistoryFragment
  }
}
    ${ProfessionalHistoryFragment}
${InternationalAddressFragment}
${AuditEntryFragment}`
export const DeleteProfessionalHistoryDocument = `
    mutation deleteProfessionalHistory($providerId: ID!, $ids: [ID!]!) {
  deleteProfessionalHistory(providerId: $providerId, ids: $ids) {
    ...ProfessionalHistoryFragment
  }
}
    ${ProfessionalHistoryFragment}
${InternationalAddressFragment}
${AuditEntryFragment}`
export const UpsertIdentifiersDocument = `
    mutation upsertIdentifiers($providerId: ID!, $content: [ProviderIdentifierInput!]!) {
  upsertIdentifiers(providerId: $providerId, content: $content) {
    ...ProviderIdentifierFragment
  }
}
    ${ProviderIdentifierFragment}`
export const DeleteIdentifiersDocument = `
    mutation deleteIdentifiers($providerId: ID!, $identifierIds: [ID!]!) {
  deleteIdentifiers(providerId: $providerId, identifierIds: $identifierIds) {
    ...ProviderIdentifierFragment
  }
}
    ${ProviderIdentifierFragment}`
export const UpdateProviderCredentialingDocument = `
    mutation updateProviderCredentialing($providerId: ID!, $content: ProviderCredentialingInput!) {
  updateProviderCredentialing(providerId: $providerId, content: $content) {
    ...ProviderCredentialingFragment
  }
}
    ${ProviderCredentialingFragment}
${InternationalAddressFragment}
${EncryptedValueFragment}`
export const UpsertProviderExternalAccountsDocument = `
    mutation upsertProviderExternalAccounts($providerId: ID!, $content: [ProviderExternalAccountInput!]!) {
  upsertProviderExternalAccounts(providerId: $providerId, content: $content) {
    ...ProviderExternalAccountFragment
  }
}
    ${ProviderExternalAccountFragment}
${EncryptedValueFragment}`
export const DeleteProviderExternalAccountsDocument = `
    mutation deleteProviderExternalAccounts($providerId: ID!, $providerExternalAccountIds: [ID!]!) {
  deleteProviderExternalAccounts(
    providerId: $providerId
    providerExternalAccountIds: $providerExternalAccountIds
  ) {
    ...ProviderExternalAccountFragment
  }
}
    ${ProviderExternalAccountFragment}
${EncryptedValueFragment}`
export const BulkUpdateInsurancePlansDocument = `
    mutation bulkUpdateInsurancePlans($content: [BulkInsurancePlanUpdateInput!]!) {
  bulkUpdateInsurancePlans(content: $content) {
    ...InsurancePlanFullFragment
  }
}
    ${InsurancePlanFullFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}
${TocConfigurationFragment}`
export const GetProvidersMinimalDocument = `
    query getProvidersMinimal {
  getProviders {
    ...ProviderMinimalFragment
  }
}
    ${ProviderMinimalFragment}
${MinimalProviderLicenseFragment}`
export const GetProvidersDocument = `
    query getProviders {
  getProviders {
    ...SearchProviderFragment
  }
}
    ${SearchProviderFragment}
${BaseProviderFragment}
${ExpectedHoursFragment}
${PractMgrReferenceFragment}
${EmploymentFragment}
${ProviderIdentifierFragment}
${MinimalInsurancePlanParticipantFragment}
${MinimalProviderLicenseFragment}`
export const GetProvidersPagedDocument = `
    query getProvidersPaged($searchAfter: AWSJSON, $pageSize: Int) {
  getProviders(searchAfter: $searchAfter, pageSize: $pageSize) {
    ...SearchProviderFragment
  }
}
    ${SearchProviderFragment}
${BaseProviderFragment}
${ExpectedHoursFragment}
${PractMgrReferenceFragment}
${EmploymentFragment}
${ProviderIdentifierFragment}
${MinimalInsurancePlanParticipantFragment}
${MinimalProviderLicenseFragment}`
export const GetProviderDocument = `
    query getProvider($id: ID!) {
  getProvider(_id: $id) {
    ...ProviderFragment
  }
}
    ${ProviderFragment}
${BaseProviderFragment}
${ExpectedHoursFragment}
${PractMgrReferenceFragment}
${EmploymentFragment}
${ProviderIdentifierFragment}
${FullInsurancePlanParticipantFragment}
${FullInsurancePlanPartialFragment}
${AttachmentAnnotationFragment}
${FileFragment}
${ProviderLicenseFragment}
${AuditEntryFragment}
${UserSummaryDisplayNamesFragment}
${ProviderTagFragment}`
export const GetProviderLicenseRequestsDocument = `
    query getProviderLicenseRequests($providerId: ID!) {
  getProvider(_id: $providerId) {
    _id
    licenseRequests {
      ...ProviderLicenseRequestFragment
    }
  }
}
    ${ProviderLicenseRequestFragment}
${AuditEntryFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const GetProviderByCareManagerIdDocument = `
    query getProviderByCareManagerId($id: ID!) {
  getProviderByCareManagerId(careManagerId: $id) {
    ...ProviderFragment
  }
}
    ${ProviderFragment}
${BaseProviderFragment}
${ExpectedHoursFragment}
${PractMgrReferenceFragment}
${EmploymentFragment}
${ProviderIdentifierFragment}
${FullInsurancePlanParticipantFragment}
${FullInsurancePlanPartialFragment}
${AttachmentAnnotationFragment}
${FileFragment}
${ProviderLicenseFragment}
${AuditEntryFragment}
${UserSummaryDisplayNamesFragment}
${ProviderTagFragment}`
export const GetEmploymentByProviderIdDocument = `
    query getEmploymentByProviderId($providerId: ID!) {
  getEmploymentByProviderId(providerId: $providerId) {
    ...EmploymentFragment
  }
}
    ${EmploymentFragment}`
export const GetInsurancePlansDocument = `
    query getInsurancePlans {
  getInsurancePlans {
    ...InsurancePlanFullFragment
  }
}
    ${InsurancePlanFullFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}
${TocConfigurationFragment}`
export const GetAllInsurancePlansDocument = `
    query getAllInsurancePlans {
  getInsurancePlans {
    ...InsurancePlanFullFragment
  }
  getOutOfNetworkInsurancePlans {
    ...InsurancePlanFullFragment
  }
}
    ${InsurancePlanFullFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}
${TocConfigurationFragment}`
export const GetInsuranceForVerificationDocument = `
    query getInsuranceForVerification {
  getInsurancePlans {
    ...VerificationInsurancePlanFragment
  }
  getOutOfNetworkInsurancePlans {
    ...VerificationInsurancePlanFragment
    status
  }
}
    ${VerificationInsurancePlanFragment}`
export const GetAllInsuranceMinimalDocument = `
    query getAllInsuranceMinimal {
  getInsurancePlans {
    ...AllInsurancePlansMinimalFragment
  }
  getOutOfNetworkInsurancePlans {
    ...AllInsurancePlansMinimalFragment
  }
}
    ${AllInsurancePlansMinimalFragment}`
export const GetActiveInsurancePlansDocument = `
    query getActiveInsurancePlans {
  getInsurancePlans {
    ...SearchInsurancePlanFragment
  }
}
    ${SearchInsurancePlanFragment}`
export const GetInheritingProvidersDocument = `
    query getInheritingProviders($providerId: ID!, $insurancePlanIds: [ID!]!) {
  getInheritingProviders(
    providerId: $providerId
    insurancePlanIds: $insurancePlanIds
  ) {
    ...ProviderPlanParticipantFragment
  }
}
    ${ProviderPlanParticipantFragment}
${FullInsurancePlanPartialFragment}
${PractMgrReferenceFragment}`
export const GetLocationsDocument = `
    query getLocations {
  getLocations {
    ...LocationFragment
  }
}
    ${LocationFragment}
${CodeableConceptFragment}`
export const GetLocationsWhDetailsDocument = `
    query getLocationsWhDetails {
  getLocations {
    id
    name
    description
    physicalType {
      ...CodeableConceptFragment
    }
    address {
      ...AddressFragment
    }
    identifiers {
      ...IdentifierFragment
    }
  }
}
    ${CodeableConceptFragment}
${AddressFragment}
${IdentifierFragment}`
export const GetPmAggregatesDocument = `
    query getPMAggregates {
  getLocations {
    ...LocationFragment
  }
  getInsurancePlans {
    ...AllInsurancePlansMinimalFragment
  }
}
    ${LocationFragment}
${CodeableConceptFragment}
${AllInsurancePlansMinimalFragment}`
export const GetProviderDocumentDocument = `
    query getProviderDocument($providerId: ID!, $documentId: ID!) {
  getProviderDocument(providerId: $providerId, documentId: $documentId) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetProviderDocumentsByProviderIdDocument = `
    query getProviderDocumentsByProviderId($providerId: ID!) {
  getProviderDocumentsByProviderId(providerId: $providerId) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetVerifiedProviderDocumentDocument = `
    query getVerifiedProviderDocument($providerId: ID!, $documentId: ID!) {
  getVerifiedProviderDocument(providerId: $providerId, documentId: $documentId) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetVerifiedProviderDocumentsByProviderIdDocument = `
    query getVerifiedProviderDocumentsByProviderId($providerId: ID!) {
  getVerifiedProviderDocumentsByProviderId(providerId: $providerId) {
    ...ProviderDocumentFragment
  }
}
    ${ProviderDocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetPayerEnrollmentsByProviderIdDocument = `
    query getPayerEnrollmentsByProviderId($providerId: ID!) {
  getPayerEnrollmentsByProviderId(providerId: $providerId) {
    ...PayerEnrollmentFragment
  }
}
    ${PayerEnrollmentFragment}
${PayerSummaryFrag}
${AttachmentAnnotationFragment}
${PractMgrReferenceFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetPayersDocument = `
    query getPayers {
  getPayers {
    ...PayerFragment
  }
}
    ${PayerFragment}
${PracticeMgrAnnotationFragment}
${PractMgrReferenceFragment}`
export const GetPayersSummaryDocument = `
    query getPayersSummary {
  getPayers {
    ...PayerSummaryFrag
  }
}
    ${PayerSummaryFrag}`
export const GetProfessionalHistoryDocument = `
    query getProfessionalHistory($providerId: ID!) {
  getProfessionalHistory(providerId: $providerId) {
    ...ProfessionalHistoryFragment
  }
}
    ${ProfessionalHistoryFragment}
${InternationalAddressFragment}
${AuditEntryFragment}`
export const GetProfessionalHistoryByIdDocument = `
    query getProfessionalHistoryById($id: ID!) {
  getProfessionalHistoryById(id: $id) {
    ...ProfessionalHistoryFragment
  }
}
    ${ProfessionalHistoryFragment}
${InternationalAddressFragment}
${AuditEntryFragment}`
export const GetProviderCredentialingDocument = `
    query getProviderCredentialing($providerId: ID!) {
  getProviderCredentialing(providerId: $providerId) {
    ...ProviderCredentialingFragment
  }
}
    ${ProviderCredentialingFragment}
${InternationalAddressFragment}
${EncryptedValueFragment}`
export const GetProviderExternalAccountsDocument = `
    query getProviderExternalAccounts($providerId: ID!) {
  getProviderExternalAccounts(providerId: $providerId) {
    ...ProviderExternalAccountFragment
  }
}
    ${ProviderExternalAccountFragment}
${EncryptedValueFragment}`
export const GetPracticeStatesDocument = `
    query getPracticeStates {
  getPracticeStates {
    ...PracticeStateFragment
  }
}
    ${PracticeStateFragment}`
export const GetPracticeTaxEntitiesDocument = `
    query getPracticeTaxEntities {
  getPracticeTaxEntities {
    ...PracticeTaxEntityFragment
  }
}
    ${PracticeTaxEntityFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateProvider: build.mutation<
      Types.UpdateProvider,
      Types.UpdateProviderVariables
    >({
      query: (variables) => ({ document: UpdateProviderDocument, variables }),
    }),
    appendInsurancePlanParticipants: build.mutation<
      Types.AppendInsurancePlanParticipants,
      Types.AppendInsurancePlanParticipantsVariables
    >({
      query: (variables) => ({
        document: AppendInsurancePlanParticipantsDocument,
        variables,
      }),
    }),
    updateInsurancePlanParticipant: build.mutation<
      Types.UpdateInsurancePlanParticipant,
      Types.UpdateInsurancePlanParticipantVariables
    >({
      query: (variables) => ({
        document: UpdateInsurancePlanParticipantDocument,
        variables,
      }),
    }),
    removeInsurancePlanParticipants: build.mutation<
      Types.RemoveInsurancePlanParticipants,
      Types.RemoveInsurancePlanParticipantsVariables
    >({
      query: (variables) => ({
        document: RemoveInsurancePlanParticipantsDocument,
        variables,
      }),
    }),
    upsertInsurancePlanParticipants: build.mutation<
      Types.UpsertInsurancePlanParticipants,
      Types.UpsertInsurancePlanParticipantsVariables
    >({
      query: (variables) => ({
        document: UpsertInsurancePlanParticipantsDocument,
        variables,
      }),
    }),
    createInsurancePlan: build.mutation<
      Types.CreateInsurancePlan,
      Types.CreateInsurancePlanVariables
    >({
      query: (variables) => ({
        document: CreateInsurancePlanDocument,
        variables,
      }),
    }),
    updateInsurancePlan: build.mutation<
      Types.UpdateInsurancePlan,
      Types.UpdateInsurancePlanVariables
    >({
      query: (variables) => ({
        document: UpdateInsurancePlanDocument,
        variables,
      }),
    }),
    deleteInsurancePlan: build.mutation<
      Types.DeleteInsurancePlan,
      Types.DeleteInsurancePlanVariables
    >({
      query: (variables) => ({
        document: DeleteInsurancePlanDocument,
        variables,
      }),
    }),
    appendProviderLicenses: build.mutation<
      Types.AppendProviderLicenses,
      Types.AppendProviderLicensesVariables
    >({
      query: (variables) => ({
        document: AppendProviderLicensesDocument,
        variables,
      }),
    }),
    updateProviderLicenses: build.mutation<
      Types.UpdateProviderLicenses,
      Types.UpdateProviderLicensesVariables
    >({
      query: (variables) => ({
        document: UpdateProviderLicensesDocument,
        variables,
      }),
    }),
    removeProviderLicenses: build.mutation<
      Types.RemoveProviderLicenses,
      Types.RemoveProviderLicensesVariables
    >({
      query: (variables) => ({
        document: RemoveProviderLicensesDocument,
        variables,
      }),
    }),
    addProviderLicenseRequests: build.mutation<
      Types.AddProviderLicenseRequests,
      Types.AddProviderLicenseRequestsVariables
    >({
      query: (variables) => ({
        document: AddProviderLicenseRequestsDocument,
        variables,
      }),
    }),
    updateProviderLicenseRequests: build.mutation<
      Types.UpdateProviderLicenseRequests,
      Types.UpdateProviderLicenseRequestsVariables
    >({
      query: (variables) => ({
        document: UpdateProviderLicenseRequestsDocument,
        variables,
      }),
    }),
    removeProviderLicenseRequests: build.mutation<
      Types.RemoveProviderLicenseRequests,
      Types.RemoveProviderLicenseRequestsVariables
    >({
      query: (variables) => ({
        document: RemoveProviderLicenseRequestsDocument,
        variables,
      }),
    }),
    appendProviderDocuments: build.mutation<
      Types.AppendProviderDocuments,
      Types.AppendProviderDocumentsVariables
    >({
      query: (variables) => ({
        document: AppendProviderDocumentsDocument,
        variables,
      }),
    }),
    updateProviderDocuments: build.mutation<
      Types.UpdateProviderDocuments,
      Types.UpdateProviderDocumentsVariables
    >({
      query: (variables) => ({
        document: UpdateProviderDocumentsDocument,
        variables,
      }),
    }),
    removeProviderDocuments: build.mutation<
      Types.RemoveProviderDocuments,
      Types.RemoveProviderDocumentsVariables
    >({
      query: (variables) => ({
        document: RemoveProviderDocumentsDocument,
        variables,
      }),
    }),
    appendVerifiedProviderDocuments: build.mutation<
      Types.AppendVerifiedProviderDocuments,
      Types.AppendVerifiedProviderDocumentsVariables
    >({
      query: (variables) => ({
        document: AppendVerifiedProviderDocumentsDocument,
        variables,
      }),
    }),
    updateVerifiedProviderDocuments: build.mutation<
      Types.UpdateVerifiedProviderDocuments,
      Types.UpdateVerifiedProviderDocumentsVariables
    >({
      query: (variables) => ({
        document: UpdateVerifiedProviderDocumentsDocument,
        variables,
      }),
    }),
    removeVerifiedProviderDocuments: build.mutation<
      Types.RemoveVerifiedProviderDocuments,
      Types.RemoveVerifiedProviderDocumentsVariables
    >({
      query: (variables) => ({
        document: RemoveVerifiedProviderDocumentsDocument,
        variables,
      }),
    }),
    createPayerEnrollments: build.mutation<
      Types.CreatePayerEnrollments,
      Types.CreatePayerEnrollmentsVariables
    >({
      query: (variables) => ({
        document: CreatePayerEnrollmentsDocument,
        variables,
      }),
    }),
    updatePayerEnrollments: build.mutation<
      Types.UpdatePayerEnrollments,
      Types.UpdatePayerEnrollmentsVariables
    >({
      query: (variables) => ({
        document: UpdatePayerEnrollmentsDocument,
        variables,
      }),
    }),
    deletePayerEnrollments: build.mutation<
      Types.DeletePayerEnrollments,
      Types.DeletePayerEnrollmentsVariables
    >({
      query: (variables) => ({
        document: DeletePayerEnrollmentsDocument,
        variables,
      }),
    }),
    createPayers: build.mutation<
      Types.CreatePayers,
      Types.CreatePayersVariables
    >({
      query: (variables) => ({ document: CreatePayersDocument, variables }),
    }),
    updatePayers: build.mutation<
      Types.UpdatePayers,
      Types.UpdatePayersVariables
    >({
      query: (variables) => ({ document: UpdatePayersDocument, variables }),
    }),
    deletePayers: build.mutation<
      Types.DeletePayers,
      Types.DeletePayersVariables
    >({
      query: (variables) => ({ document: DeletePayersDocument, variables }),
    }),
    createProfessionalHistory: build.mutation<
      Types.CreateProfessionalHistory,
      Types.CreateProfessionalHistoryVariables
    >({
      query: (variables) => ({
        document: CreateProfessionalHistoryDocument,
        variables,
      }),
    }),
    updateProfessionalHistory: build.mutation<
      Types.UpdateProfessionalHistory,
      Types.UpdateProfessionalHistoryVariables
    >({
      query: (variables) => ({
        document: UpdateProfessionalHistoryDocument,
        variables,
      }),
    }),
    deleteProfessionalHistory: build.mutation<
      Types.DeleteProfessionalHistory,
      Types.DeleteProfessionalHistoryVariables
    >({
      query: (variables) => ({
        document: DeleteProfessionalHistoryDocument,
        variables,
      }),
    }),
    upsertIdentifiers: build.mutation<
      Types.UpsertIdentifiers,
      Types.UpsertIdentifiersVariables
    >({
      query: (variables) => ({
        document: UpsertIdentifiersDocument,
        variables,
      }),
    }),
    deleteIdentifiers: build.mutation<
      Types.DeleteIdentifiers,
      Types.DeleteIdentifiersVariables
    >({
      query: (variables) => ({
        document: DeleteIdentifiersDocument,
        variables,
      }),
    }),
    updateProviderCredentialing: build.mutation<
      Types.UpdateProviderCredentialing,
      Types.UpdateProviderCredentialingVariables
    >({
      query: (variables) => ({
        document: UpdateProviderCredentialingDocument,
        variables,
      }),
    }),
    upsertProviderExternalAccounts: build.mutation<
      Types.UpsertProviderExternalAccounts,
      Types.UpsertProviderExternalAccountsVariables
    >({
      query: (variables) => ({
        document: UpsertProviderExternalAccountsDocument,
        variables,
      }),
    }),
    deleteProviderExternalAccounts: build.mutation<
      Types.DeleteProviderExternalAccounts,
      Types.DeleteProviderExternalAccountsVariables
    >({
      query: (variables) => ({
        document: DeleteProviderExternalAccountsDocument,
        variables,
      }),
    }),
    bulkUpdateInsurancePlans: build.mutation<
      Types.BulkUpdateInsurancePlans,
      Types.BulkUpdateInsurancePlansVariables
    >({
      query: (variables) => ({
        document: BulkUpdateInsurancePlansDocument,
        variables,
      }),
    }),
    getProvidersMinimal: build.query<
      Types.GetProvidersMinimal,
      Types.GetProvidersMinimalVariables | void
    >({
      query: (variables) => ({
        document: GetProvidersMinimalDocument,
        variables,
      }),
    }),
    getProviders: build.query<
      Types.GetProviders,
      Types.GetProvidersVariables | void
    >({
      query: (variables) => ({ document: GetProvidersDocument, variables }),
    }),
    getProvidersPaged: build.query<
      Types.GetProvidersPaged,
      Types.GetProvidersPagedVariables | void
    >({
      query: (variables) => ({
        document: GetProvidersPagedDocument,
        variables,
      }),
    }),
    getProvider: build.query<Types.GetProvider, Types.GetProviderVariables>({
      query: (variables) => ({ document: GetProviderDocument, variables }),
    }),
    getProviderLicenseRequests: build.query<
      Types.GetProviderLicenseRequests,
      Types.GetProviderLicenseRequestsVariables
    >({
      query: (variables) => ({
        document: GetProviderLicenseRequestsDocument,
        variables,
      }),
    }),
    getProviderByCareManagerId: build.query<
      Types.GetProviderByCareManagerId,
      Types.GetProviderByCareManagerIdVariables
    >({
      query: (variables) => ({
        document: GetProviderByCareManagerIdDocument,
        variables,
      }),
    }),
    getEmploymentByProviderId: build.query<
      Types.GetEmploymentByProviderId,
      Types.GetEmploymentByProviderIdVariables
    >({
      query: (variables) => ({
        document: GetEmploymentByProviderIdDocument,
        variables,
      }),
    }),
    getInsurancePlans: build.query<
      Types.GetInsurancePlans,
      Types.GetInsurancePlansVariables | void
    >({
      query: (variables) => ({
        document: GetInsurancePlansDocument,
        variables,
      }),
    }),
    getAllInsurancePlans: build.query<
      Types.GetAllInsurancePlans,
      Types.GetAllInsurancePlansVariables | void
    >({
      query: (variables) => ({
        document: GetAllInsurancePlansDocument,
        variables,
      }),
    }),
    getInsuranceForVerification: build.query<
      Types.GetInsuranceForVerification,
      Types.GetInsuranceForVerificationVariables | void
    >({
      query: (variables) => ({
        document: GetInsuranceForVerificationDocument,
        variables,
      }),
    }),
    getAllInsuranceMinimal: build.query<
      Types.GetAllInsuranceMinimal,
      Types.GetAllInsuranceMinimalVariables | void
    >({
      query: (variables) => ({
        document: GetAllInsuranceMinimalDocument,
        variables,
      }),
    }),
    getActiveInsurancePlans: build.query<
      Types.GetActiveInsurancePlans,
      Types.GetActiveInsurancePlansVariables | void
    >({
      query: (variables) => ({
        document: GetActiveInsurancePlansDocument,
        variables,
      }),
    }),
    getInheritingProviders: build.query<
      Types.GetInheritingProviders,
      Types.GetInheritingProvidersVariables
    >({
      query: (variables) => ({
        document: GetInheritingProvidersDocument,
        variables,
      }),
    }),
    getLocations: build.query<
      Types.GetLocations,
      Types.GetLocationsVariables | void
    >({
      query: (variables) => ({ document: GetLocationsDocument, variables }),
    }),
    getLocationsWhDetails: build.query<
      Types.GetLocationsWhDetails,
      Types.GetLocationsWhDetailsVariables | void
    >({
      query: (variables) => ({
        document: GetLocationsWhDetailsDocument,
        variables,
      }),
    }),
    getPMAggregates: build.query<
      Types.GetPmAggregates,
      Types.GetPmAggregatesVariables | void
    >({
      query: (variables) => ({ document: GetPmAggregatesDocument, variables }),
    }),
    getProviderDocument: build.query<
      Types.GetProviderDocument,
      Types.GetProviderDocumentVariables
    >({
      query: (variables) => ({
        document: GetProviderDocumentDocument,
        variables,
      }),
    }),
    getProviderDocumentsByProviderId: build.query<
      Types.GetProviderDocumentsByProviderId,
      Types.GetProviderDocumentsByProviderIdVariables
    >({
      query: (variables) => ({
        document: GetProviderDocumentsByProviderIdDocument,
        variables,
      }),
    }),
    getVerifiedProviderDocument: build.query<
      Types.GetVerifiedProviderDocument,
      Types.GetVerifiedProviderDocumentVariables
    >({
      query: (variables) => ({
        document: GetVerifiedProviderDocumentDocument,
        variables,
      }),
    }),
    getVerifiedProviderDocumentsByProviderId: build.query<
      Types.GetVerifiedProviderDocumentsByProviderId,
      Types.GetVerifiedProviderDocumentsByProviderIdVariables
    >({
      query: (variables) => ({
        document: GetVerifiedProviderDocumentsByProviderIdDocument,
        variables,
      }),
    }),
    getPayerEnrollmentsByProviderId: build.query<
      Types.GetPayerEnrollmentsByProviderId,
      Types.GetPayerEnrollmentsByProviderIdVariables
    >({
      query: (variables) => ({
        document: GetPayerEnrollmentsByProviderIdDocument,
        variables,
      }),
    }),
    getPayers: build.query<Types.GetPayers, Types.GetPayersVariables | void>({
      query: (variables) => ({ document: GetPayersDocument, variables }),
    }),
    getPayersSummary: build.query<
      Types.GetPayersSummary,
      Types.GetPayersSummaryVariables | void
    >({
      query: (variables) => ({ document: GetPayersSummaryDocument, variables }),
    }),
    getProfessionalHistory: build.query<
      Types.GetProfessionalHistory,
      Types.GetProfessionalHistoryVariables
    >({
      query: (variables) => ({
        document: GetProfessionalHistoryDocument,
        variables,
      }),
    }),
    getProfessionalHistoryById: build.query<
      Types.GetProfessionalHistoryById,
      Types.GetProfessionalHistoryByIdVariables
    >({
      query: (variables) => ({
        document: GetProfessionalHistoryByIdDocument,
        variables,
      }),
    }),
    getProviderCredentialing: build.query<
      Types.GetProviderCredentialing,
      Types.GetProviderCredentialingVariables
    >({
      query: (variables) => ({
        document: GetProviderCredentialingDocument,
        variables,
      }),
    }),
    getProviderExternalAccounts: build.query<
      Types.GetProviderExternalAccounts,
      Types.GetProviderExternalAccountsVariables
    >({
      query: (variables) => ({
        document: GetProviderExternalAccountsDocument,
        variables,
      }),
    }),
    getPracticeStates: build.query<
      Types.GetPracticeStates,
      Types.GetPracticeStatesVariables | void
    >({
      query: (variables) => ({
        document: GetPracticeStatesDocument,
        variables,
      }),
    }),
    getPracticeTaxEntities: build.query<
      Types.GetPracticeTaxEntities,
      Types.GetPracticeTaxEntitiesVariables | void
    >({
      query: (variables) => ({
        document: GetPracticeTaxEntitiesDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
